import React from 'react'
import { Grid } from "@mui/material"

import OneWayTable from "Pages/AnalyzersV2/OneWay/Table"
import OneWayChart from "Pages/AnalyzersV2/OneWay/Chart"


export default function OneWayContent() {
	return <Grid container spacing={2}>
		<OneWayTable/>
		<Grid item xs={12}>
			<OneWayChart/>
		</Grid>
	</Grid>
}